import styles from "./nav.module.css";
import { Button, ButtonType } from "@/components/button";
import { useAuth } from "@/context/AuthContext";
import React, {useState} from "react";
import { FitLayout } from "@/components/fitLayout";
import { Animation, LottieAnimation } from "@/components/animation";

interface NavLinkProps {
  label: string;
  href: string;
}

interface DropdownAction {
  label: string;
  url?: string;
  icon?: any;
  action?: () => void;
}

interface NavProps {
  scrolled: boolean;
  logo?: any;
  links?: NavLinkProps[];
  userActions?: DropdownAction[];
  className?: string;
  classNameScrolled?: string;
  showLogin?: boolean;
  showLoginLoading?:boolean;
}

const DropDownAction = (props : {action : DropdownAction, onClick : () => void}) => {
  const {
    action,
    onClick
  } = props;

  const content = (
    <>
      {action.icon &&
        <div className={styles.dropdown_action_icon}>
          {action.icon}
        </div>
      }
      <div className={styles.dropdown_action_value}>{action.label}</div>
    </>
  );

  if(action.url){
    return (
      <a href={action.url} className={styles.dropdown_action} onClick={onClick}>{content}</a>
    )
  }

  return (
    <div className={styles.dropdown_action} onClick={() => {
      onClick();
      action?.action?.();
    }}>
      {content}
    </div>
  );
}



export const Nav = (props: NavProps) => {
  const { user, loading } = useAuth();
  const { logo, links, className, classNameScrolled, showLogin = false, userActions, showLoginLoading = false } = props;
  const [userDropdownVisible, setUserDropdownVisible] = useState(false);

  return (
    <div
      className={
        styles.nav +
        (props.scrolled
          ? " " +
            (styles.scrolled +
              (classNameScrolled ? " " + classNameScrolled : ""))
          : "") +
        (className ? " " + className : "")
      }
    >
      <FitLayout>
        <div className={styles.nav_content}>
          <a className={styles.nav__logo} href={"/"}>
            {logo && logo}
          </a>
          <div className={styles.nav__links}>
            {links && links.map((link, i) => (
                  <Button
                    label={link.label}
                    className={styles.link}
                    href={link.href}
                    key={i}
                    type={
                      props.scrolled ? ButtonType.DEFAULT : ButtonType.SECONDARY
                    }
                  />
                ))}
            

            {user && (
              <div
                className={styles.user_info}
                onClick={() => {
                  setUserDropdownVisible(true);
                }}
              >
                {user.email[0].toUpperCase()}
              </div>
            )}
            {showLogin && !user && !loading && (
              <Button label="Iniciar sesión" className={styles.log_in} href="/login"/>
            )}
            {userDropdownVisible && userActions &&
              <div className={styles.dropdown}>
                <div className={styles.dropdown_background} onClick={() => setUserDropdownVisible(false)}></div>
                {userActions.map((userAction : DropdownAction, i) => 
                  <DropDownAction key={i} action={userAction} onClick={() => setUserDropdownVisible(false)}/>
                )}
              </div>
            }
            {showLoginLoading && !user && loading && 
              <div
                className={styles.user_info_loading}
              >
                <Animation animation={LottieAnimation.LOADING}/>
              </div>
            }

            <Button
                    label={'Iniciar sesión'}
                    className={styles.link}
                    href={'https://app.keperin.com/'}
                    type={
                      props.scrolled ? ButtonType.DEFAULT : ButtonType.SECONDARY
                    }
                  />
            </div>
        </div>
      </FitLayout>
    </div>
  );
};
